import { Routes, Route } from 'react-router-dom';
import { TooltipProvider } from '@/components/ui/tooltip';
import { Toaster } from '@/components/ui/toaster';
import { toast } from 'sonner';
import PublicEvent from '@/pages/PublicEvent';
import PublicEventAdmin from '@/pages/PublicEventAdmin';
import NotFound from '@/pages/NotFound';

export function PublicApp() {
  return (
    <TooltipProvider>
      <Routes>
        <Route path="/public-event/:slug" element={<PublicEvent />} />
        <Route path="/public-event/:slug/admin" element={<PublicEventAdmin />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Toaster />
    </TooltipProvider>
  );
}